var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0.875V0.125H0V0.875C0 2.4593 1.11817 4.02674 2.51964 5.14811C2.72846 5.3152 2.94752 5.47571 3.17525 5.628L1.71065 7.51106C1.37158 7.94701 1.45011 8.57528 1.88606 8.91435C2.32201 9.25342 2.95028 9.17489 3.28935 8.73894L4.9747 6.57206C5.70691 6.85943 6.47704 7.04999 7.25 7.10705V8.875C7.25 9.42728 7.69772 9.875 8.25 9.875C8.80228 9.875 9.25 9.42728 9.25 8.875V6.98641C10.068 6.83986 10.8829 6.58035 11.6483 6.22365L13.4691 8.49969C13.8141 8.93096 14.4434 9.00088 14.8747 8.65587C15.306 8.31086 15.3759 7.68157 15.0309 7.25031L13.376 5.18172C14.8753 4.03121 16 2.3727 16 0.375H14.5C14.5 1.81242 13.6654 3.11142 12.3414 4.0828C11.0173 5.05433 9.29214 5.625 7.73188 5.625C6.27062 5.625 4.68544 4.95999 3.45678 3.97689C2.20246 2.97326 1.5 1.7907 1.5 0.875Z",
    fill: "#6C7774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close_eye.cc5ae8e2a4bc8c29b0c6a4dd3b99bbb0.svg";
export { ForwardRef as ReactComponent };